import IcAddReaction from "@assets/reactions/add-reactions.svg";
import { reactionCount } from "@helper/utils";
import { ReactionProp } from "@typings/Reactions";
import type { ReactElement } from "react";

import { getReactionGif } from "./helper/getReactionGif";

export type ArticleReactionsProps = {
  reactions: ReactionProp[];
  reactionsUser: string;
  limit?: 1 | 2;
  referer?: string;
};

export const ArticleReactions = ({
  reactions,
  reactionsUser,
  limit = 2,
  referer = "article",
}: ArticleReactionsProps): ReactElement => {
  if (reactions.length === 0) {
    return (
      <span key={`reaction-empty-${referer}`} data-testid="no-reaction"></span>
    );
  }

  const totalReactions =
    reactions.reduce((sum, reaction) => sum + reaction.count, 0) || 0;

  if (totalReactions === 0) {
    return (
      <div className="w-[46px] flex items-center justify-center rounded-[50px] border-red-100 border-2 py-1.5 px-0.5">
        <img
          src={IcAddReaction}
          width={24}
          height={24}
          data-testid="add-reaction"
          alt="add-reaction"
        />
      </div>
    );
  }

  const topReactions = [...reactions]
    .filter((reaction) => reaction.count > 0)
    .sort((a, b) => b.count - a.count)
    .slice(0, limit);

  return (
    <div
      data-testid={`reactions-${referer}-${reactionsUser}`}
      className="w-fit flex items-center justify-center gap-0.5 rounded-[50px] border-2 py-2.5 px-3 border-red-100"
    >
      <div className="flex items-center">
        {topReactions.map((reaction, index) => (
          <span
            key={`reactions-span-${referer}-${reaction.id}`}
            data-testid={`reaction-${index}`}
            className={index > 0 ? "-ml-1" : ""}
          >
            <img
              src={getReactionGif(reaction.id)}
              alt={reaction.text}
              width={20}
            />
          </span>
        ))}
      </div>
      <span className="text-sm text-red-100 leading-[100%]">
        {reactionCount(totalReactions)}
      </span>
    </div>
  );
};
